import { useMutation, useQuery, useQueryClient } from "react-query"
import { addUnbillablePeriodsAsync, deleteUnbillablePeriodAsync, getUnbillablePeriod, getUnbillablePeriodGpsLog, updateUnbillablePeriodAsync, AddUnbillablePeriodsRequest, visitHasTimeEntries, getUnbillableVisit, updateUnbillableVisitNotes } from "./timeTrackingPeriodApi"
import { UnbillableTimeWithBreakDeduction } from './timeTrackingPeriod'

export const useUnbillablePeriod = (periodId: string) => {
  return useQuery({
    queryKey: ['unbillable-period', periodId],
    queryFn: () => getUnbillablePeriod(periodId),
    enabled: !!periodId
  })
}

export const useUnbillablePeriodGpsLog = (periodId: string) => {
  return useQuery({ queryKey: ['unbillable-period', periodId, 'gps-log'], queryFn: () => getUnbillablePeriodGpsLog(periodId) })
}

export const useUpdateUnbillablePeriod = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ period, submit }: { period: UnbillableTimeWithBreakDeduction, submit?: boolean }) => updateUnbillablePeriodAsync(period, submit),
    onSuccess: (_, { period }) => {
      queryClient.invalidateQueries(['unbillable-period', period.id])
    }
  })
}

export const useAddUnbillablePeriods = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ request, submit }: { request: AddUnbillablePeriodsRequest, submit?: boolean }) => addUnbillablePeriodsAsync(request, submit),
    onSuccess: () => {
      queryClient.invalidateQueries(['unbillable-period'])
    }
  })
}

export const useDeleteUnbillablePeriod = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (periodId: string) => deleteUnbillablePeriodAsync(periodId),
    onSuccess: () => {
      queryClient.invalidateQueries(['unbillable-period'])
    }
  })
}

export const useVisitHasTimeEntries = (visitId: string) => {
  return useQuery({
    queryKey: ['visit-has-time-entries', visitId],
    queryFn: () => visitHasTimeEntries(visitId),
    enabled: !!visitId
  })
}

export const useUnbillableVisit = (visitId: string | undefined) => {
  return useQuery({
    queryKey: ['unbillable-visit', visitId],
    queryFn: () => getUnbillableVisit(visitId!),
    enabled: !!visitId
  })
}

export const useUpdateUnbillableVisitNotes = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({visitId, notes}: { visitId: string, notes: string | undefined}) => updateUnbillableVisitNotes(visitId, notes),
    onSuccess: (_, {visitId}) => {
      queryClient.invalidateQueries(['unbillable-visit', visitId])
    }
  })
}